"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBox = void 0;
const React = require("react");
const theme_1 = require("../modules/theme");
const layout_1 = require("../modules/layout");
const FontAwesome_1 = require("react-native-vector-icons/FontAwesome");
const test_1 = require("../modules/test");
const react_native_1 = require("react-native");
class TextBox extends React.Component {
    constructor() {
        super(...arguments);
        this.input = null;
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const { icon } = this.props;
            const styles = react_native_1.StyleSheet.create({
                container: Object.assign({ paddingHorizontal: 16, paddingVertical: 8, borderWidth: 1, borderColor: theme.borderColor1, borderRadius: 3 }, (icon ? { flexDirection: 'row' } : {})),
                icon: {
                    color: theme.textColor2,
                    fontSize: (0, layout_1.isTablet)() ? 21 : 19,
                    marginRight: 10,
                    alignSelf: 'center',
                    minHeight: 22
                },
                label: {
                    color: theme.textColor2,
                    fontFamily: theme.fontFamily3,
                    fontSize: (0, layout_1.isTablet)() ? 15 : 12,
                    lineHeight: 16
                },
                input: Object.assign(Object.assign({ color: theme.textColor1, fontFamily: this.props.value ? theme.fontFamily1 : theme.fontFamily3, fontWeight: 'normal', fontSize: 16, minHeight: 22, padding: 0, margin: 0 }, (react_native_1.Platform.OS === 'web' ? { outlineStyle: 'none' } : {})), (icon ? { flex: 1 } : {})),
                readonly: {
                    backgroundColor: theme.disabledColor
                }
            });
            return styles;
        };
        this.focus = () => {
            if (this.input && this.props.editable) {
                this.input.focus();
            }
        };
        this.renderInput = (props) => React.createElement(react_native_1.TextInput, Object.assign({}, props));
    }
    render() {
        const { label, style, labelStyle, editable, inputRef, renderInput, icon, onPress } = this.props;
        const styles = this.getStyles();
        const incomingProps = {
            nativeID: this.props.nativeID,
            testID: (0, test_1.getTestID)(this.props.nativeID),
            autoFocus: this.props.autoFocus,
            value: this.props.value,
            onChangeText: this.props.onChange,
            onBlur: this.props.onBlur,
            style: [
                styles.input,
                this.props.inputStyle,
                this.props.editable ? null : styles.readonly
            ],
            underlineColorAndroid: 'transparent',
            //@ts-ignore: no Android < 6 essa é a prop que deixa o underline transparente. https://stackoverflow.com/questions/40478246/remove-underline-in-inputtext-in-react-native
            borderWidth: 0,
            placeholder: this.props.placeholder,
            secureTextEntry: this.props.secureTextEntry,
            multiline: this.props.multiline,
            editable: this.props.editable,
            keyboardType: this.props.keyboardType,
            maxLength: this.props.maxLength,
            onSubmitEditing: this.props.onSubmitEditing,
            autoCapitalize: this.props.autoCapitalize,
            autoCorrect: this.props.autoCorrect,
            returnKeyType: react_native_1.Platform.OS === 'ios' &&
                this.props.keyboardType === 'numeric' &&
                this.props.returnKeyType === 'next'
                ? 'done'
                : this.props.returnKeyType,
            ref: (input) => {
                this.input = input;
                if (inputRef)
                    inputRef(input);
            },
            selection: this.props.selection,
            onKeyPress: (event) => {
                if (!this.props.onKeyPress) {
                    return;
                }
                this.props.onKeyPress(react_native_1.Platform.OS === 'web' ? event : event.nativeEvent);
            }
        };
        return (React.createElement(react_native_1.TouchableWithoutFeedback, { accessible: false, onPress: () => (onPress ? onPress() : this.focus()), ref: ref => {
                if (react_native_1.Platform.OS === 'web' && ref != null) {
                    // @ts-ignore na web, a ref recebida é o próprio elemento DOM
                    ref.tabIndex = -1;
                }
            } },
            React.createElement(react_native_1.View, { style: [styles.container, style, editable ? null : styles.readonly] },
                icon ? (React.createElement(FontAwesome_1.default, { name: icon, style: styles.icon })) : (React.createElement(react_native_1.Text, { style: [styles.label, labelStyle] }, label)),
                renderInput
                    ? renderInput(incomingProps)
                    : this.renderInput(incomingProps))));
    }
}
exports.TextBox = TextBox;
TextBox.defaultProps = {
    editable: true,
    autoCorrect: false,
    blurOnSubmit: true
};
